(function () {
  'use strict';

  var LAYOUT_LABELS = {centre:'Centre bowl', double:'Double bowl'};
  var MODEL_LABELS = {'all-door':'All-Door','door-drawer':'Door & Drawer'};

  function money(value) {
    return new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD'}).format(Number(value || 0));
  }
  function optionById(list,id) {
    return (list || []).find(function (item) { return String(item.id) === String(id); }) || null;
  }
  function button(className,value,title,subtitle,selected) {
    var el=document.createElement('button');
    el.type='button';
    el.className=className+(selected?' is-selected':'');
    el.dataset.value=String(value);
    el.setAttribute('aria-pressed',selected?'true':'false');
    el.innerHTML='<strong>'+title+'</strong>'+(subtitle?'<small>'+subtitle+'</small>':'');
    return el;
  }

  function init(root) {
    if (!window.ADPArchieConfiguratorData || root.dataset.initialized === 'true') return;
    root.dataset.initialized='true';
    document.body.classList.add('adp-archie-product');

    var data=window.ADPArchieConfiguratorData;
    var state={
      step:0,
      configuration_name:'',
      mounting:'wall-hung',
      requested_depth:'full-depth',
      model_type:null,
      width:null,
      layout:null,
      top_mode:null,
      cabinet_finish:null,
      handle:null,
      top_material:null,
      top_finish:null,
      basin:null,
      waste:null,
      power_point:null,
      extra:null,
      statement_top:null,
      tap_hole:null,
      tap_hole_left:null,
      tap_hole_right:null,
      customer_notes:'',
      quantity:1,
      confirmed:false
    };

    var refs={
      stages:Array.prototype.slice.call(root.querySelectorAll('[data-stage]')),
      progress:Array.prototype.slice.call(root.querySelectorAll('[data-progress]')),
      back:root.querySelector('[data-back]'),
      next:root.querySelector('[data-next]'),
      validation:root.querySelector('[data-validation]'),
      review:root.querySelector('[data-review]'),
      total:root.querySelector('[data-estimated-total]'),
      livePrice:root.querySelector('[data-live-price]'),
      livePriceBreakdown:root.querySelector('[data-live-price-breakdown]'),
      livePriceStatus:root.querySelector('[data-live-price-status]'),
      quantityInput:root.querySelector('[data-field="quantity"]'),
      quantityMinus:root.querySelector('[data-quantity-minus]'),
      quantityPlus:root.querySelector('[data-quantity-plus]'),
      configurationName:root.querySelector('[data-field="configuration_name"]'),
      checkoutMessage:root.querySelector('[data-checkout-message]'),
      quoteAction:root.querySelector('[data-quote-action]'),
      anotherConfiguration:root.querySelector('[data-another-configuration]'),
      confirmation:root.querySelector('[data-order-confirmation]'),
      cabinetSearch:root.querySelector('[data-search="cabinet"]'),
      topSearch:root.querySelector('[data-search="top"]'),
      basinSearch:root.querySelector('[data-search="basin"]'),
      cabinetGrid:root.querySelector('[data-grid="cabinet"]'),
      handleGrid:root.querySelector('[data-grid="handle"]'),
      topGrid:root.querySelector('[data-grid="top"]'),
      basinGrid:root.querySelector('[data-grid="basin"]'),
      topMaterial:root.querySelector('[data-field="top_material"]'),
      topGroup:root.querySelector('[data-top-finish-group]'),
      topHint:root.querySelector('[data-top-hint]'),
      noBasin:root.querySelector('[data-no-basin]'),
      tapHoleGroup:root.querySelector('[data-tap-hole-group]'),
      wasteGroup:root.querySelector('[data-waste-group]'),
      statementTopGroup:root.querySelector('[data-statement-top-group]')
    };

    function key() {
      return state.model_type && state.width ? state.model_type+':'+state.width : '';
    }
    function availableOn(item) {
      if (!item) return false;
      if (item.required_material && item.required_material !== state.top_material) return false;
      if (item.available_on && item.available_on.length && item.available_on.indexOf(key()) === -1) return false;
      return !item.out_of_stock;
    }
    function itemPrice(item) {
      if (!item) return 0;
      if (item.price_by_base && Object.prototype.hasOwnProperty.call(item.price_by_base,key())) {
        return Number(item.price_by_base[key()] || 0);
      }
      return Number(item.price || 0);
    }
    function currentDataVariant() {
      if (!state.model_type || !state.width || !state.layout || !state.top_mode) return null;
      return (data.variants || []).find(function (v) {
        return v.model_type===state.model_type &&
          Number(v.width)===Number(state.width) &&
          v.layout===state.layout &&
          v.top_mode===state.top_mode;
      }) || null;
    }
    function basinCount() { return state.layout==='double'?2:1; }
    function selectedCabinet(){return optionById(data.cabinet_finishes,state.cabinet_finish);}
    function selectedHandle(){return optionById(data.handles,state.handle);}
    function selectedTop(){return optionById(data.top_finishes,state.top_finish);}
    function selectedBasin(){return optionById(data.basins,state.basin);}
    function selectedWaste(){return optionById(data.wastes,state.waste);}
    function selectedPower(){return optionById(data.power_points,state.power_point);}
    function selectedExtra(){return optionById(data.extras,state.extra);}
    function selectedUpgrade(){return optionById(data.statement_tops,state.statement_top);}
    function selectedTap(){return optionById(data.tap_holes,state.tap_hole);}
    function multipliedPrice(item) {
      if (!item) return 0;
      var count=item.multiply_by_basin_count && state.layout==='double'?2:1;
      return itemPrice(item)*count;
    }
    function priceBreakdown() {
      var variant=currentDataVariant();
      var base=variant && !variant.quote_only ? Number(variant.price || 0) : 0;
      var top=selectedTop();
      var topSurcharge=state.top_mode==='standard-top' && top && top.adjustment_percent ? base*Number(top.adjustment_percent)/100 : 0;
      var basin=selectedBasin(),waste=selectedWaste(),power=selectedPower(),extra=selectedExtra(),upgrade=selectedUpgrade();
      return {
        base:base,
        top:topSurcharge,
        basin:multipliedPrice(basin),
        waste:multipliedPrice(waste),
        power:itemPrice(power),
        extra:itemPrice(extra),
        upgrade:state.top_mode==='standard-top'?itemPrice(upgrade):0,
        total:base+topSurcharge+multipliedPrice(basin)+multipliedPrice(waste)+itemPrice(power)+itemPrice(extra)+(state.top_mode==='standard-top'?itemPrice(upgrade):0),
        quoteOnly:!!(variant && variant.quote_only)
      };
    }
    function tapHoleSummary() {
      if (state.top_mode==='cabinet-only') return 'Not applicable';
      if (state.layout==='double') {
        var left=optionById(data.tap_holes,state.tap_hole_left);
        var right=optionById(data.tap_holes,state.tap_hole_right);
        return 'Left basin: '+(left?left.name:'Not selected')+' · Right basin: '+(right?right.name:'Not selected');
      }
      return selectedTap()?selectedTap().name:'Not selected';
    }

    function resetDependentSelections() {
      if (state.model_type && state.width) {
        var allowedWidths=Object.keys(data.rules.model_types_by_width).filter(function (w) {
          return data.rules.model_types_by_width[w].indexOf(state.model_type)!==-1;
        }).map(Number);
        if (allowedWidths.indexOf(Number(state.width))===-1) state.width=null;
      }
      if (state.width) {
        var layouts=data.rules.layouts_by_width[String(state.width)] || ['centre'];
        if (state.layout && layouts.indexOf(state.layout)===-1) state.layout=null;
      }
      ['cabinet_finish','handle','top_finish','basin','waste','power_point','extra','statement_top'].forEach(function (field) {
        var listName={cabinet_finish:'cabinet_finishes',handle:'handles',top_finish:'top_finishes',basin:'basins',waste:'wastes',power_point:'power_points',extra:'extras',statement_top:'statement_tops'}[field];
        var item=optionById(data[listName],state[field]);
        if (item && !availableOn(item)) state[field]=null;
      });
      if (state.layout==='double') {
        if (state.tap_hole) {
          if (!state.tap_hole_left) state.tap_hole_left=state.tap_hole;
          if (!state.tap_hole_right) state.tap_hole_right=state.tap_hole;
        }
        state.tap_hole=null;
      } else {
        if (!state.tap_hole && state.tap_hole_left && state.tap_hole_left===state.tap_hole_right) state.tap_hole=state.tap_hole_left;
        state.tap_hole_left=null;
        state.tap_hole_right=null;
      }
      if (state.top_mode==='cabinet-only') {
        state.top_material=null;
        state.top_finish=null;
        state.statement_top=null;
        state.tap_hole=null;
        state.tap_hole_left=null;
        state.tap_hole_right=null;
      }
      state.confirmed=false;
      if(refs.confirmation) refs.confirmation.checked=false;
    }

    function renderChoiceGroup(name,options) {
      var host=root.querySelector('[data-choice-group="'+name+'"]');
      if(!host) return;
      host.innerHTML='';
      options.forEach(function (opt) {
        var el=button('adp-archie__choice',opt.value,opt.title,opt.subtitle,String(state[name])===String(opt.value));
        el.addEventListener('click',function () {
          state[name]=opt.value;
          resetDependentSelections();
          render();
        });
        host.appendChild(el);
      });
    }

    function renderBaseChoices() {
      var modelTypes=['all-door','door-drawer'];
      if (state.width) modelTypes=(data.rules.model_types_by_width[String(state.width)] || modelTypes);
      renderChoiceGroup('model_type',modelTypes.map(function (value) {
        return {value:value,title:MODEL_LABELS[value],subtitle:value==='all-door'?'Door-only arch fronts':'Doors plus ADP Deluxe drawers'};
      }));

      var widths=data.widths.filter(function (width) {
        return !state.model_type || (data.rules.model_types_by_width[String(width)] || []).indexOf(state.model_type)!==-1;
      });
      renderChoiceGroup('width',widths.map(function (width) {
        return {value:width,title:width+'mm',subtitle:width+'W × 700H × 500D'};
      }));

      var layouts=state.width ? (data.rules.layouts_by_width[String(state.width)] || []) : ['centre','double'];
      renderChoiceGroup('layout',layouts.map(function (layout) {
        return {value:layout,title:LAYOUT_LABELS[layout],subtitle:layout==='double'?'Two matching basins':'Single centre basin'};
      }));

      renderChoiceGroup('top_mode',[
        {value:'standard-top',title:'With benchtop',subtitle:'40mm top + matching 180mm splashback'},
        {value:'cabinet-only',title:'Cabinet only',subtitle:'No benchtop supplied · quote required'}
      ]);
    }

    function swatches(items,host,selectedId,search,type) {
      if(!host) return;
      var term=String(search||'').trim().toLowerCase();
      var filtered=(items||[]).filter(availableOn).filter(function (item) {
        return !term || (item.name+' '+(item.material||'')+' '+(item.sku||'')).toLowerCase().indexOf(term)!==-1;
      });
      host.innerHTML='';
      filtered.forEach(function (item) {
        var el=document.createElement('button');
        el.type='button';
        el.className='adp-archie__swatch'+(String(selectedId)===String(item.id)?' is-selected':'');
        el.dataset.value=item.id;
        el.setAttribute('aria-pressed',String(selectedId)===String(item.id)?'true':'false');
        el.innerHTML=(item.image?'<img src="'+item.image+'" alt="" loading="lazy">':'')+'<span>'+item.name+'</span>';
        el.addEventListener('click',function () {
          state[type]=item.id;
          if(type==='top_finish') state.top_material=item.material;
          state.confirmed=false;
          if(refs.confirmation) refs.confirmation.checked=false;
          render();
        });
        host.appendChild(el);
      });
    }

    function renderFinishes() {
      swatches(data.cabinet_finishes,refs.cabinetGrid,state.cabinet_finish,refs.cabinetSearch&&refs.cabinetSearch.value,'cabinet_finish');
      swatches(data.handles,refs.handleGrid,state.handle,'','handle');
      if(!refs.topGroup) return;
      refs.topGroup.hidden=state.top_mode==='cabinet-only';
      if(state.top_mode==='cabinet-only') return;
      var materials=unique((data.top_finishes||[]).map(function (x) {return x.material;}));
      if(state.top_material && materials.indexOf(state.top_material)===-1) state.top_material=null;
      if(refs.topMaterial) {
        refs.topMaterial.innerHTML='<option value="">Choose material</option>'+materials.map(function (material) {
          return '<option value="'+material+'"'+(material===state.top_material?' selected':'')+'>'+material+'</option>';
        }).join('');
      }
      var materialItems=state.top_material ? data.top_finishes.filter(function (x) {return x.material===state.top_material;}) : data.top_finishes;
      if(selectedTop() && state.top_material && selectedTop().material!==state.top_material) state.top_finish=null;
      swatches(materialItems,refs.topGrid,state.top_finish,refs.topSearch&&refs.topSearch.value,'top_finish');
      if(refs.topHint) {
        refs.topHint.textContent=state.top_material==='20mm Caesarstone Mineral'
          ? 'Caesarstone Mineral carries ADP\'s 25% surcharge on the base vanity.'
          : state.top_material ? 'This material is included in the standard-top base price.' : 'Choose a benchtop material and finish.';
        refs.topHint.classList.toggle('is-warning',state.top_material==='20mm Caesarstone Mineral');
      }
    }
    function unique(values){return Array.from(new Set(values));}

    function renderBasins() {
      if(!refs.basinGrid) return;
      var term=refs.basinSearch?refs.basinSearch.value.trim().toLowerCase():'';
      var items=(data.basins||[]).filter(availableOn).filter(function (item) {
        return !term || (item.name+' '+item.sku).toLowerCase().indexOf(term)!==-1;
      });
      if(!term) {
        var chosen=selectedBasin();
        items=items.slice(0,24);
        if(chosen && items.indexOf(chosen)===-1) items.unshift(chosen);
      }
      refs.basinGrid.innerHTML='';
      items.forEach(function (item) {
        var el=document.createElement('button');
        var count=item.multiply_by_basin_count && state.layout==='double'?2:1;
        el.type='button';
        el.className='adp-archie__basin-card'+(String(state.basin)===String(item.id)?' is-selected':'');
        el.setAttribute('aria-pressed',String(state.basin)===String(item.id)?'true':'false');
        el.innerHTML=(item.image?'<img src="'+item.image+'" alt="" loading="lazy">':'')+
          '<span>'+item.name+'</span><span class="adp-archie__price-add">+'+money(itemPrice(item)*count)+(count===2?' for 2':'')+'</span>';
        el.addEventListener('click',function () {state.basin=item.id;render();});
        refs.basinGrid.appendChild(el);
      });
      if(refs.noBasin) {
        refs.noBasin.classList.toggle('is-selected',state.basin===null);
        refs.noBasin.setAttribute('aria-pressed',state.basin===null?'true':'false');
      }
    }

    function fillSelect(el,items,selected,noneLabel) {
      if(!el) return;
      var options=noneLabel?'<option value="">'+noneLabel+'</option>':'';
      options+=(items||[]).filter(availableOn).map(function (item) {
        var count=item.multiply_by_basin_count && state.layout==='double'?2:1;
        var price=itemPrice(item)*count;
        return '<option value="'+item.id+'"'+(String(selected)===String(item.id)?' selected':'')+'>'+item.name+(price?' (+'+money(price)+(count===2?' for 2':'')+')':'')+'</option>';
      }).join('');
      el.innerHTML=options;
    }

    function renderDetails() {
      var tap=root.querySelector('[data-field="tap_hole"]');
      if(tap) tap.innerHTML='<option value="">Choose tap-hole drilling</option>'+(data.tap_holes||[]).map(function (item) {
        return '<option value="'+item.id+'"'+(String(state.tap_hole)===String(item.id)?' selected':'')+'>'+item.name+'</option>';
      }).join('');
      fillSelect(root.querySelector('[data-field="waste"]'),data.wastes,state.waste,'Choose plug & waste');
      fillSelect(root.querySelector('[data-field="power_point"]'),data.power_points,state.power_point,'No in-drawer power point');
      fillSelect(root.querySelector('[data-field="extra"]'),data.extras,state.extra,'No optional extra');
      fillSelect(root.querySelector('[data-field="statement_top"]'),data.statement_tops,state.statement_top,'Standard 40mm benchtop');
      if(refs.tapHoleGroup) refs.tapHoleGroup.hidden=state.top_mode==='cabinet-only'||state.layout==='double';
      if(refs.statementTopGroup) refs.statementTopGroup.hidden=state.top_mode==='cabinet-only';
      if(refs.wasteGroup) refs.wasteGroup.hidden=false;
    }

    function selectionProperties() {
      var variant=currentDataVariant();
      var price=priceBreakdown();
      return {
        'Configuration Name':state.configuration_name||'Not named',
        'ADP Base SKU':variant&&variant.sku?variant.sku:'Cabinet only - supplier quote required',
        'Cabinet Style':state.model_type?MODEL_LABELS[state.model_type]:'Not selected',
        'Mounting':'Wall Hung',
        'Overall Width':state.width?state.width+' mm':'Not selected',
        'Height':'700 mm',
        'Depth':'500 mm',
        'Bowl Layout':state.layout?LAYOUT_LABELS[state.layout]:'Not selected',
        'Benchtop Supply':state.top_mode==='cabinet-only'?'Cabinet Only - No Benchtop':state.top_mode==='standard-top'?'40mm Benchtop + 180mm matching splashback':'Not selected',
        'Cabinet Finish':selectedCabinet()?selectedCabinet().name:'Not selected',
        'Aria Handle':selectedHandle()?selectedHandle().name:'Not selected',
        'Benchtop Finish':state.top_mode==='cabinet-only'?'Not supplied':selectedTop()?selectedTop().material+' - '+selectedTop().name:'Not selected',
        'Benchtop Upgrade':state.top_mode==='cabinet-only'?'Not applicable':selectedUpgrade()?selectedUpgrade().name:'Standard 40mm',
        'Basin':selectedBasin()?(basinCount()+' × '+selectedBasin().name):'No basin selected',
        'Basin Code':selectedBasin()?selectedBasin().sku:'Not applicable',
        'Tap Holes':tapHoleSummary(),
        'Plug and Waste':selectedWaste()?(basinCount()+' × '+selectedWaste().name):'Not selected',
        'In-Drawer Power':selectedPower()?selectedPower().name:'None',
        'Optional Extra':selectedExtra()?selectedExtra().name:'None',
        'Quantity':state.quantity,
        'Customer Notes':state.customer_notes||'None',
        '_ADP Estimated Total':price.quoteOnly?'Quotation required':money(price.total*state.quantity),
        '_ADP Data Checked':data.source_retrieved_at
      };
    }

    function quoteReasons() {
      var p=priceBreakdown(),reasons=[];
      if(p.quoteOnly) reasons.push('cabinet-only base requires supplier quote');
      if(p.top>0) reasons.push('Caesarstone 25% surcharge');
      if(p.basin>0) reasons.push('basin add-on');
      if(p.waste>0) reasons.push('waste finish add-on');
      if(p.power>0) reasons.push('in-drawer power');
      if(p.extra>0) reasons.push('optional extra');
      if(p.upgrade>0) reasons.push('benchtop upgrade');
      return reasons;
    }

    function renderReview() {
      if(!refs.review) return;
      var props=selectionProperties();
      refs.review.innerHTML=Object.keys(props).map(function (name) {
        return '<div class="adp-archie__review-row"><span>'+name+'</span><strong>'+props[name]+'</strong></div>';
      }).join('');
      var p=priceBreakdown();
      if(refs.total) refs.total.textContent=p.quoteOnly?'Quotation required':money(p.total*state.quantity);
      if(refs.checkoutMessage) refs.checkoutMessage.textContent=quoteReasons().length
        ? 'This remains an ADP estimate until OZ Bathroom confirms the supplier order.'
        : 'Base configuration selected. Supplier availability and freight still require confirmation.';
    }

    function renderLivePrice() {
      if(!refs.livePrice) return;
      var variant=currentDataVariant(),p=priceBreakdown();
      if(!variant) {
        refs.livePrice.textContent='—';
        if(refs.livePriceBreakdown) refs.livePriceBreakdown.textContent='Choose a complete Archie base';
        if(refs.livePriceStatus) refs.livePriceStatus.textContent='Width · cabinet style · bowl · benchtop';
        return;
      }
      if(p.quoteOnly) {
        refs.livePrice.textContent='Quote required';
        if(refs.livePriceBreakdown) refs.livePriceBreakdown.textContent='Cabinet only · no public standalone base price';
        if(refs.livePriceStatus) refs.livePriceStatus.textContent='OZ Bathroom will confirm the supplier price';
        return;
      }
      refs.livePrice.textContent=money(p.total*state.quantity);
      var extras=p.total-p.base;
      if(refs.livePriceBreakdown) refs.livePriceBreakdown.textContent=state.quantity>1
        ? state.quantity+' configured vanities × '+money(p.total)+' each'
        : 'Base '+money(p.base)+(extras>0?' + selected extras '+money(extras):' · no priced extras selected');
      if(refs.livePriceStatus) refs.livePriceStatus.textContent=quoteReasons().length?'Live ADP estimate · final order price to be confirmed':'Current ADP base estimate';
    }

    function renderStage() {
      refs.stages.forEach(function (el,i) {el.classList.toggle('is-active',i===state.step);});
      refs.progress.forEach(function (el,i) {el.classList.toggle('is-active',i<=state.step);});
      if(refs.back) refs.back.disabled=state.step===0;
      if(refs.next) {
        var labels=['Next: finishes','Next: basin','Next: order details','Next: review','Configuration reviewed'];
        refs.next.textContent=labels[state.step];
        refs.next.disabled=state.step===4;
      }
    }

    function render() {
      renderBaseChoices();
      renderFinishes();
      renderBasins();
      renderDetails();
      renderReview();
      renderLivePrice();
      renderStage();
    }

    function validateBase(values) {
      return (data.variants||[]).find(function (v) {
        return v.model_type===values.model_type &&
          Number(v.width)===Number(values.width) &&
          v.layout===values.layout &&
          v.top_mode===values.top_mode;
      }) || null;
    }

    root.adpArchieApplyRequirements=function (values) {
      var problems=[];
      var allowed=['mounting','requested_depth','model_type','width','layout','top_mode','cabinet_finish','handle','top_material','top_finish','basin','waste','power_point','extra','statement_top','tap_hole','tap_hole_left','tap_hole_right','quantity','configuration_name','customer_notes'];
      if(!values||typeof values!=='object'||Object.keys(values).some(function (k) {return allowed.indexOf(k)===-1;})) {
        return {ok:false,errors:['Unsupported Archie configuration field.']};
      }
      var proposed=Object.assign({},state,values,{confirmed:false});
      if(proposed.mounting && proposed.mounting!=='wall-hung') problems.push('Archie is wall hung only.');
      if(proposed.requested_depth && proposed.requested_depth!=='full-depth') problems.push('Archie is fixed at 500 mm deep.');
      var base=validateBase(proposed);
      if(!base) problems.push('That exact Archie base combination is not listed.');

      var proposedKey=proposed.model_type&&proposed.width?proposed.model_type+':'+proposed.width:'';
      var map={cabinet_finish:'cabinet_finishes',handle:'handles',top_finish:'top_finishes',basin:'basins',waste:'wastes',power_point:'power_points',extra:'extras',statement_top:'statement_tops',tap_hole:'tap_holes',tap_hole_left:'tap_holes',tap_hole_right:'tap_holes'};
      Object.keys(map).forEach(function (field) {
        if(proposed[field]==null||proposed[field]==='') return;
        var explicit=Object.prototype.hasOwnProperty.call(values,field);
        var item=optionById(data[map[field]],proposed[field]);
        if(!item) {
          if(explicit) problems.push('Unknown '+field.replace(/_/g,' ')+'.');
          else proposed[field]=null;
          return;
        }
        if(item.available_on&&item.available_on.length&&item.available_on.indexOf(proposedKey)===-1) {
          if(explicit) problems.push(item.name+' is unavailable for this Archie base.');
          else proposed[field]=null;
        }
      });

      var top=optionById(data.top_finishes,proposed.top_finish);
      if(top) proposed.top_material=top.material;
      var upgrade=optionById(data.statement_tops,proposed.statement_top);
      if(upgrade&&upgrade.required_material&&upgrade.required_material!==proposed.top_material) {
        if(Object.prototype.hasOwnProperty.call(values,'statement_top')) problems.push('Royale benchtop is available in Durasein only.');
        else proposed.statement_top=null;
      }

      if (state.layout!==proposed.layout && !Object.prototype.hasOwnProperty.call(values,'tap_hole') && !Object.prototype.hasOwnProperty.call(values,'tap_hole_left') && !Object.prototype.hasOwnProperty.call(values,'tap_hole_right')) {
        proposed.tap_hole=null;
        proposed.tap_hole_left=null;
        proposed.tap_hole_right=null;
      }
      if (proposed.layout==='double') {
        if (proposed.tap_hole) {
          if (!proposed.tap_hole_left) proposed.tap_hole_left=proposed.tap_hole;
          if (!proposed.tap_hole_right) proposed.tap_hole_right=proposed.tap_hole;
        }
        proposed.tap_hole=null;
      } else {
        proposed.tap_hole_left=null;
        proposed.tap_hole_right=null;
      }

      if(proposed.top_mode==='cabinet-only') {
        if(values.top_finish||values.statement_top||values.tap_hole||values.tap_hole_left||values.tap_hole_right) problems.push('Cabinet only cannot apply supplied-benchtop details.');
        proposed.top_material=null;
        proposed.top_finish=null;
        proposed.statement_top=null;
        proposed.tap_hole=null;
        proposed.tap_hole_left=null;
        proposed.tap_hole_right=null;
      }

      if(!Number.isInteger(Number(proposed.quantity))||Number(proposed.quantity)<1||Number(proposed.quantity)>99) problems.push('Quantity must be 1 to 99.');
      if(proposed.configuration_name&&(typeof proposed.configuration_name!=='string'||proposed.configuration_name.length>60)) problems.push('Use a configuration name up to 60 characters.');
      if(typeof proposed.customer_notes!=='string'||proposed.customer_notes.length>600) problems.push('Notes must be 600 characters or fewer.');

      if(problems.length) return {ok:false,errors:problems};
      Object.assign(state,proposed,{mounting:'wall-hung',requested_depth:'full-depth',step:0,confirmed:false});
      if(refs.configurationName) refs.configurationName.value=state.configuration_name||'';
      if(refs.quantityInput) refs.quantityInput.value=state.quantity;
      if(refs.confirmation) refs.confirmation.checked=false;
      render();
      return {ok:true,errors:[]};
    };

    root.adpArchieGetState=function () {return Object.assign({},state);};
    root.adpArchieGetSummary=function () {
      var props=selectionProperties();
      return Object.keys(props).map(function (name) {return name+': '+props[name];}).join('\n');
    };

    function changeField(event) {
      var el=event.target.closest('[data-field]');
      if(!el) return;
      var field=el.dataset.field;
      if(field==='quantity') state.quantity=Math.max(1,Math.min(99,Number(el.value||1)));
      else if(field==='configuration_name') state.configuration_name=el.value.slice(0,60);
      else if(field==='top_material') {
        state.top_material=el.value||null;
        if(selectedTop()&&selectedTop().material!==state.top_material) state.top_finish=null;
        if(selectedUpgrade()&&selectedUpgrade().required_material&&selectedUpgrade().required_material!==state.top_material) state.statement_top=null;
      } else state[field]=el.value||null;
      resetDependentSelections();
      render();
    }
    root.addEventListener('change',changeField);
    root.addEventListener('input',function (event) {
      var el=event.target.closest('[data-field="configuration_name"],[data-field="quantity"]');
      if(!el) return;
      if(el.dataset.field==='configuration_name') state.configuration_name=el.value.slice(0,60);
      else state.quantity=Math.max(1,Math.min(99,Number(el.value||1)));
      renderReview();renderLivePrice();
    });
    if(refs.cabinetSearch) refs.cabinetSearch.addEventListener('input',renderFinishes);
    if(refs.topSearch) refs.topSearch.addEventListener('input',renderFinishes);
    if(refs.basinSearch) refs.basinSearch.addEventListener('input',renderBasins);
    if(refs.noBasin) refs.noBasin.addEventListener('click',function () {state.basin=null;render();});
    if(refs.quantityMinus) refs.quantityMinus.addEventListener('click',function () {state.quantity=Math.max(1,state.quantity-1);if(refs.quantityInput)refs.quantityInput.value=state.quantity;renderReview();renderLivePrice();});
    if(refs.quantityPlus) refs.quantityPlus.addEventListener('click',function () {state.quantity=Math.min(99,state.quantity+1);if(refs.quantityInput)refs.quantityInput.value=state.quantity;renderReview();renderLivePrice();});

    if(refs.back) refs.back.addEventListener('click',function () {if(state.step>0){state.step-=1;renderStage();}});
    if(refs.next) refs.next.addEventListener('click',function () {
      if(!currentDataVariant()) {if(refs.validation)refs.validation.textContent='Choose cabinet style, width, bowl layout and benchtop supply first.';return;}
      if(state.step<4) state.step+=1;
      if(refs.validation) refs.validation.textContent='';
      renderStage();
    });
    if(refs.confirmation) refs.confirmation.addEventListener('change',function () {state.confirmed=this.checked;});
    if(refs.quoteAction) refs.quoteAction.addEventListener('click',function () {
      var summary=root.adpArchieGetSummary();
      if(navigator.clipboard&&navigator.clipboard.writeText) navigator.clipboard.writeText(summary).catch(function(){});
      var enquiry=document.getElementById('enquiryNowBtn');
      if(enquiry) enquiry.click();
      if(refs.validation) refs.validation.textContent='Configuration copied. Paste it into the enquiry message so OZ Bathroom can confirm the order.';
    });
    if(refs.anotherConfiguration) refs.anotherConfiguration.addEventListener('click',function () {
      Object.assign(state,{
        step:0,configuration_name:'',mounting:'wall-hung',requested_depth:'full-depth',model_type:null,width:null,layout:null,top_mode:null,
        cabinet_finish:null,handle:null,top_material:null,top_finish:null,basin:null,waste:null,power_point:null,extra:null,statement_top:null,
        tap_hole:null,tap_hole_left:null,tap_hole_right:null,customer_notes:'',quantity:1,confirmed:false
      });
      if(refs.configurationName) refs.configurationName.value='';
      if(refs.quantityInput) refs.quantityInput.value=1;
      if(refs.cabinetSearch) refs.cabinetSearch.value='';
      if(refs.topSearch) refs.topSearch.value='';
      if(refs.basinSearch) refs.basinSearch.value='';
      if(refs.confirmation) refs.confirmation.checked=false;
      if(refs.validation) refs.validation.textContent='';
      render();
    });

    render();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-adp-archie-configurator]')).forEach(init);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',boot);
}());
